import request from '../utils/request'

//产品信息页-获取产品类型
export function getProductType (superiorTypeId) {
  return request({
    url: `/landmark/apply/types`,
    method: 'GET',
    params:superiorTypeId

  })
}


//上传pdf文件
export function uploadPdfFile (data) {
  return request({
    url: `/landmark/apply/uploadPdfFile`,
    method: 'POST',
    data

  })
}

//上传图片文件
export function uploadImgFile(data) {
  return request({
    url: `/landmark/apply/uploadImgFile`,
    method: 'POST',
    data

  })
}

//上传doc文件
export function uploadDocFile(data) {
  return request({
    url: `/landmark/apply/uploadDocFile`,
    method: 'POST',
    data

  })
}

//上传压缩文件
export function uploadZipFile(data) {
  return request({
    url: `/landmark/apply/uploadCompressedFile`,
    method: 'POST',
    data

  })
}

//暂存草稿箱
export function saveDrafts (data) {
  return request({
    url: `/landmark/apply/stage`,
    method: 'POST',
    data

  })
}


//提交申请
export function submitApplication (data) {
  return request({
    url: `/landmark/apply/save`,
    method: 'POST',
    data

  })
}
























//首页小标数据
export function getConsoleNumber () {
  return request({
    url: `/landmark/apply/consoleNumber`,
    method: 'GET'
  })
}
//待办清单
export function getTodolists (data) {
  return request({
    url: `/landmark/apply/todo/list`,
    method: 'POST',
    data
  })
}

//草稿箱列表

export function getDrafts () {
  return request({
    url: `/landmark/apply/drafts`,
    method: 'GET',
  })
}

//删除草稿

export function deleteDrafts (applyId) {
  return request({
    url: `/landmark/apply/delete`,
    method: 'GET',
    params:applyId
  })
}


//申请信息查询
export function getApplicationInfo (data) {
  return request({
    url: `/landmark/apply/search`,
    method: 'POST',
    data
  })
}

//获取补正通知
export function getNotice (data) {
  return request({
    url: `/landmark/apply/todo/notice`,
    method: 'GET',
    params:data
  })
}
//查看文件
export function showFile (filePath) {
  return request({
    url: `/landmark/apply/showFile`,
    responseType: 'blob',
    headers:{ 'Content-Type': 'application/json; application/octet-stream'},
    method: 'GET',
    params:{filePath}
  })
}

//查看申请详情
export function toseeDetails(applyId){
  return request({
    url: `/landmark/apply/${applyId}/detail`,
    method: 'GET'
  })
}

//下载文件
export function downloadExamFile(data) {
  return request({
    url:`/landmark/apply/downloadFile`,
    method: 'GET',
    responseType: 'blob',
    headers:{ 'Content-Type': 'application/json; application/octet-stream'},
    params:data
  })

}

//补正列表

export function record1(data,data1){
  return request({
    url: `/landmark/apply/${data1}/record`,
    method: 'POST',
    data
  })
}

//补正列表---详情
export function recordinfo(id){
  return request({
    url: `/landmark/apply/record/${id}`,
    method: 'GET'

  })
}

//异议内容、查看详情异议期信息列表

export function objectionlist(data,data1){
  return request({
    url: `/landmark/apply/${data1}/objection`,
    method: 'POST',
    data,

  })
}
//校验名称是否可用

export function checkname(data) {
  return request({
    url: `/landmark/apply/checkname`,
    method: 'GET',
    params:data
  })
}



// WEBPACK FOOTER //
// ./src/landmark-user/api/landmarkApplication1.js